module.exports = __webpack_public_path__ + "static/media/Ron.8eb22362.jpg";